import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sustainable-growth-rate-calculator',
  component: () => import('../../routes/SustainableGrowthRateCalculator.svelte'),
  card: {
    id: 'sustainable-growth-rate',
    title: 'Sustainable Growth Rate',
    description: 'Calculate the maximum rate a company can grow using only retained earnings without increasing leverage.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/sustainable-growth-rate-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Sustainable Growth Rate (SGR) Calculator — Free SGR Formula Tool',
    description:
      'Free Sustainable Growth Rate calculator uses the Higgins SGR formula (ROE × Retention Ratio) to find the maximum growth rate a company can achieve without issuing new equity. Includes SGR interpretation and comparison tables.',
  },
};

export default meta;
